<!--
File Name          : firmwareupdate.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->

<div class="component-container">
    <div class="remaining-container">
        <div class="lessons-card standard-center-card">
            <div class="standard-card-message">Updating: {{device?.deviceName}}</div>
            <div class="standard-card-message-info">{{ primary_message }}</div>
            <dx-progress-bar width="100%" [value]="syntheticProgress ?? displayedUploadProgress" [showStatus]="true"></dx-progress-bar>
            <br><br>
            <div *ngFor="let message of secondary_messages" class="standard-card-message-info">{{ message }}</div>
            <div *ngIf="showManualReconnect && !update_complete && !update_failed" class="double-button-container">
                <dx-button [text]="reselecting ? 'Connecting...' : ('Reconnect ' + (rememberedDeviceName ?? 'Device'))" [disabled]="reselecting" (onClick)="reselectDevice()" type="default"></dx-button>
            </div>
            <dx-button *ngIf="update_complete" text="Okay" (onClick)="backToLesson()" type="default"></dx-button>
            <div *ngIf="update_tap_required && !update_complete && !update_failed" class="double-button-container">
                <button type="button" class="dx-button dx-button-mode-contained dx-button-default" [disabled]="tapToFinishBusy" (click)="tapToFinishReconnect()">
                    <span class="dx-button-content">{{ tapToFinishBusy ? 'Connecting...' : ('Reconnect ' + (rememberedDeviceName ?? 'Device') + ' to finish') }}</span>
                </button>
                <div *ngIf="tapToFinishMessage" class="standard-card-message-info">{{ tapToFinishMessage }}</div>
            </div>

            <div *ngIf="update_reconnect_stuck" class="double-button-container">
                <button type="button" class="dx-button dx-button-mode-contained dx-button-default" [disabled]="otaReconnectBusy" (click)="uploadReconnectTap()">
                    <span class="dx-button-content">{{ otaReconnectBusy ? 'Connecting...' : ('Connection lost. Tap to reconnect ' + (rememberedDeviceName ?? 'Device')) }}</span>
                </button>
                <div *ngIf="otaReconnectMessage" class="standard-card-message-info">{{ otaReconnectMessage }}</div>
                <dx-button text="Download Log" (onClick)="downloadOtaLogs()" type="normal"></dx-button>
            </div>

            <div *ngIf="update_reconnect_ready" class="double-button-container">
                <dx-button text="Retry update" (onClick)="retryUpdate()" type="default"></dx-button>
                <dx-button text="Download Log" (onClick)="downloadOtaLogs()" type="normal"></dx-button>
            </div>

            <div *ngIf="update_failed && errorCount<3" class="double-button-container">
                <dx-button text="Retry" (onClick)="retryUpdate()" type="default"></dx-button>
                <dx-button text="Cancel" (onClick)="cancelUpdate()" type="normal"></dx-button>
                <dx-button text="Download Log" (onClick)="downloadOtaLogs()" type="normal"></dx-button>
            </div>
            <div *ngIf="errorCount >= 3" class="double-button-container">
                <dx-button text="Product Support" (onClick)="openProductSupport()" type="default"></dx-button>
                <dx-button text="Okay" (onClick)="backToLessonFailed()" type="default"></dx-button>
                <dx-button text="Download Log" (onClick)="downloadOtaLogs()" type="normal"></dx-button>
            </div>
        </div>
    </div>

    <dx-popup
        #selectDevicePopup
        [visible]="showSelectDevicePopup()"
        [showTitle]="true"
        [title]="'Reconnect ' + (rememberedDeviceName ?? 'Device')"
        [hideOnOutsideClick]="false"
        [dragEnabled]="false"
        [height]="400"
        [width]="400"
        maxHeight="100%"
        maxWidth="100%"
    >

        <div class="update-message">Your device lost its sensor connection. Pair again to continue. If "{{ rememberedDeviceName ?? 'your device' }}" isn't listed in the chooser yet, it may still be rebooting — cancel and try again in a few seconds.</div>
        <br>

        <button type="button" class="dx-button dx-button-mode-contained dx-button-default" [disabled]="reselecting" (click)="reselectDevice()">
            <span class="dx-button-content">{{ reselecting ? 'Connecting...' : 'Okay' }}</span>
        </button>

    </dx-popup>
</div>